import { Periodicity } from "@/service/plans";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface Companies {
  IdSubscriptionDetailCompanies: number;
  Company: { IdCompany: number; Name: string };
}

export interface PricingTier {
  name: string;
  id: number;
  price: number;
  description: string | React.ReactNode;
  allCompanies: boolean;
  listCompanies: Companies[];
  galaxPayId: number
  periodicity: Periodicity
  services: ServiceProps[];
}

export interface ServiceProps {
  IdSubscriptionService: number;
  Service: {
    Description: string;
  };
}

interface InitialStateProps {
  planSelected: PricingTier | null
}

const initialState: InitialStateProps = {
  planSelected: null,
};

const PlanSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {
    selectPlan: (state, action: PayloadAction<PricingTier>) => {
      state.planSelected = action.payload;
    },
    resetPlanSelected: (state) => {
      state.planSelected = null
    },
  },
});

export const { selectPlan, resetPlanSelected } = PlanSlice.actions;

export default PlanSlice.reducer;
